function initHomeSlideshow() {
  var slickSlideshow = $(".home-slideshow [data-init-slideshow]");
  if (slickSlideshow.length) {
    slickSlideshow.each(function () {
      var self = $(this);
      
      if (self.not(".slick-initialized")) {
        self.slick({
          pauseOnHover: true,
          dots: self.data("dots"),
          customPaging: function(slider, i) {
            if(i === 0) {
              return `<button type="button" aria-current="true"><span class="sr-only">Go to slide ${i + 1}</span></button>`;
            } else {
              return `<button type="button"><span class="sr-only">Go to slide ${i + 1}</span></button>`;
            }
          },
          slidesToScroll: 1,
          verticalSwiping: false,
          fade: self.data("fade"),
          cssEase: "ease",
          adaptiveHeight: true,
          autoplay: self.data("autoplay"),
          autoplaySpeed: self.data("autoplay-speed"),
          arrows: self.data("arrow"),
          prevArrow:
            '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="home-slideshow-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="home-slideshow-prev">Home Slideshow Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
          nextArrow:
            '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="home-slideshow-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="home-slideshow-next">Home Slideshow Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
          accessibility: false,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                arrows: false,
                dots: self.data("dots"),
              },
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
              },
            },
          ],
        });
        self.on("afterChange", function (event, slick, currentSlide, nextSlide) {
          $(this).find(`.slick-group-content`).attr("aria-current", false);
          $(this).find(`.slick-slide[data-slick-index='${currentSlide}'] .slick-group-content`).attr("aria-current", true);
          $(this).find(`.slick-slide[data-slick-index='${currentSlide}']`).attr("tabindex", 1).siblings().attr("tabindex", -1);
          if($(this).find(`.slick-dots`)){
            $(this).find(`.slick-dots li button`).removeAttr("aria-current");
            $(this).find(`.slick-dots li.slick-active button`).attr("aria-current", true);
          }
        });
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', function () {
  let scriptLoaded = false;
  let interactionTimeout;
  const slickJsSrc = window.slickJsFile.src;
  const scriptUrls = [slickJsSrc];

  // 加载并初始化脚本
  function loadSlickScript() {
    if (!scriptLoaded) {
      console.log('home slideshow slick.min.js loaded');
      initHomeSlideshow(); // 确保slick.js加载完毕后初始化幻灯片
      scriptLoaded = true;
      clearTimeout(interactionTimeout);
    }
  }

  // 用户交互后加载slick.min.js
  function humanInteraction() {
    loadSlickScript();
  }

  // 监听用户交互
  document.addEventListener('click', humanInteraction);
  document.addEventListener('scroll', humanInteraction);
  document.addEventListener('mousemove', humanInteraction);
  document.addEventListener('keydown', humanInteraction);
  document.addEventListener('touchstart', humanInteraction);

  // 如果用户在40秒内没有任何交互，则默认加载
  interactionTimeout = setTimeout(function () {
    if (!scriptLoaded) {
      loadSlickScript();
    }
  }, 10000);
});